import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const Wrapper = styled(Link)`
  box-shadow: 0 0 5px ${myPalette.dark.shadowLight};
  background-color: ${myPalette.white.main};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  text-decoration: none;
  color: ${myPalette.black.main};
  cursor: pointer;
  padding: 16px 12px;
`

export const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
`
